
import styled from 'styled-components';
import tag from 'clean-tag';
import { themeGet, textAlign, space } from 'styled-system';

export default styled(tag.input)`
  font-family: inherit;
  width: 100%;
  padding: 1em;
  border: 1px solid ${themeGet('colors.variations.gray.2')};
  border-radius: 0;
  ${textAlign};
  ${space};
  &::placeholder {
    color: ${themeGet('colors.gray')};
  }
`;
